export default "__VITE_ASSET__c8q0VKcb__"